import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/* Reddy mobile bottom nav (.footer_mobilemenu — fixed black bar, mobile-only via
   the scoped @media). Distinct from the old-app components/MobileBottomNav.jsx.
   5 items, each 20% wide (icon + label); the active route's item enlarges + bolds. */
const ITEMS = [
  { label: 'Home', icon: 'bi-house-door-fill', path: '/', active: (p) => p === '/' },
  { label: 'In-Play', icon: 'bi-broadcast', path: '/', active: () => false }, // no dedicated /inplay route; home carries live
  { label: 'Casino', icon: 'bi-dice-5-fill', path: '/casino', active: (p) => p === '/casino' },
  { label: 'Statement', icon: 'bi-clipboard-data', path: '/reports/account-statement', active: (p) => p.startsWith('/reports') },
  { label: 'Profile', icon: 'bi-person-fill', path: '/profile', active: (p) => p.startsWith('/profile') },
];

export default function MobileBottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className="footer_mobilemenu">
      {ITEMS.map((it) => (
        <a
          key={it.label}
          href="javascript:void(0);"
          className={it.active(pathname) ? 'active' : ''}
          onClick={(e) => { e.preventDefault(); navigate(it.path); }}
        >
          <i className={`bi ${it.icon}`} />
          <span>{it.label}</span>
        </a>
      ))}
    </div>
  );
}
